import ajax from '@/resources/myApi';

export class DocumentServiceFactory {
  constructor(paths) {
    this.paths = paths;
  }

  async getAll(accountId) {
    try {
      const { data } = await ajax.get(this.paths.getAll.replace(':id', accountId), {
        name: 'documents'
      })
      return data;
    } catch {}
  }

  async uploadFiles(accountId, files, documentCategoryId = 0) {
    try {
      const data = new FormData();
      const headers = { 'content-type': 'multipart/form-data' };
      
      let fullPath = this.paths.uploadFiles.replace(':id', accountId);

      if(documentCategoryId) fullPath = fullPath.replace(':documentCategoryId', documentCategoryId);
      for (let i = 0; i < files.length; i++) {
        data.append('files', files[i], files[i].name);
      }

      await ajax.post(fullPath, {
        name: 'document',
        headers,
        body: data,
      });
    } catch {}
  }

  async deleteDocument(documentId) {
    try {
      await ajax.delete(this.paths.deleteDocument.replace(':id', documentId), {
        name: 'documents'
      });
    } catch {}
  }

  async openDocument(file) {
    try {
      const { data } = await ajax.get(this.paths.openDocument.replace(':id', file.guid), {
        name: 'document',
        responseType: 'blob'
      });
      const fileUrl = URL.createObjectURL(data);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = fileUrl;
      a.download = `${file.name}${file.type}`;
      a.click();
      window.URL.revokeObjectURL(fileUrl);
      document.body.removeChild(a);
    } catch {}
  }
}
